import { render } from "./CompanySearch.vue?vue&type=template&id=f34987c6"
import script from "./CompanySearch.vue?vue&type=script&lang=js"
export * from "./CompanySearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__